import axios from "axios";
import { isEmpty } from "underscore";
import storageService from "./services/storage.service";
import HttpStatusCode from "./utils/httpStatusCodes.utils";

const businessPortalClient = axios.create();

businessPortalClient.interceptors.request.use((config) => {
  const storedToken = storageService.getTokenFromStorage();

  if (!isEmpty(storedToken)) {
    config.headers!.Authorization = `Bearer ${storedToken}`;
  }

  return config;
});

businessPortalClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === HttpStatusCode.UNAUTHORIZED) {
      storageService.removeTokenFromStorage();
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default businessPortalClient;
